import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {Col, List, Row, FloatButton, Form, Spin, Select, Tooltip} from "antd";
import {createSearchParams, generatePath, useNavigate, useSearchParams} from "react-router-dom";
import {ROUTE_PATH} from "../../constants";
import React, {memo, useCallback, useEffect, useMemo, useState} from "react";
import {FormItem, InnerTabs, MyBreadcrumb, MyButton, MyText, OuterTabs} from "../../components";
import {selectStore} from "../../store/selector";
import {
  getPlanListAction,
  getPlansCurrentCtpListAction,
  getPlansCurrentCtpListActionDone,
  getPlansCurrentFilterAction,
  getPlansCurrentFilterActionDone
} from "../../store/pages/plans/actions";
import {CardItem} from "../Journal/index.styles";
import {setFormAction} from "../../store/common/actions";
import {RootState} from "../../store";
import dayjs from "dayjs";
import _, {identity, pickBy} from "lodash";


interface LevelObject {
  name: string,
  value?: string,
  key: string,
  url?: string,
  filter_url?: string,
}

let item = {
  name: '',
  value: '',
  key: '',
  url: '',
  filter_url: '',
}

const initialState = {
  1: item,
  2: item,
  3: item,
}


export const Plans = () => {
  const {t} = useTranslation("common")
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [adminForm] = Form.useForm()
  const [searchParams, setSearchParams] = useSearchParams();

  const {
    profile: {userProfile},
    plans: {list: listState, listCurrent: listCurrentState, filter: filterState},
  }: RootState = useSelector(selectStore)

  const [tab, setTab] = useState<any>(initialState)

  useEffect(() => {
    if(userProfile.success){
      dispatch(getPlanListAction())
    }
  }, [userProfile.success])

  useEffect(() => {
    if (listState.data) {
      let firstSearchParams = searchParams.get('first')
      let secondSearchParams = searchParams.get('second')
      let thirdSearchParams = searchParams.get('third')

      let first: any = listState.data?.find((item: any) => {
        return item.key == firstSearchParams || item.value == dayjs().year() || item.secondValue == dayjs().year()
      }) || listState.data?.[0]
      let second: any = first?.children?.find((item: any) => item.key == secondSearchParams) || first?.children?.[0]
      let third: any = second?.children?.find((item: any) => item.key == thirdSearchParams) || second?.children?.[0]

      setObjects(first, second, third)

      // @ts-ignore
      adminForm.setFieldsValue(Object.fromEntries([...searchParams]))
    }
  }, [listState.data]);

  const setUrlParams = (tabs: any, filterParams?: any) => {
    let body = {
      first: tabs[1]?.key,
      second: tabs[2]?.key,
      third: tabs[3]?.key,
      ...filterParams
    }

    setSearchParams(body)
  }

  const handleClickTab = (tabLevel: number, key: string) => {
    let firstItem: any
    let secondItem: any
    let thirdItem: any

    adminForm.resetFields()

    dispatch(getPlansCurrentCtpListActionDone(null))
    dispatch(getPlansCurrentFilterActionDone(null))

    switch (tabLevel) {
      case 1:
        firstItem = listState?.data?.find((item: any) => item.key == key)
        secondItem = firstItem?.children?.[0]
        thirdItem = secondItem?.children?.[0]
        setObjects(firstItem, secondItem, thirdItem)
        break
      case 2:
        firstItem = tab[1]
        secondItem = firstItem?.children?.find((item: any) => item.key == key)
        thirdItem = secondItem?.children?.[0]
        setObjects(firstItem, secondItem, thirdItem)
        break
      case 3:
        firstItem = tab[1]
        secondItem = tab[2]
        thirdItem = secondItem?.children?.find((item: any) => item.key == key)
        setObjects(firstItem, secondItem, thirdItem)
        break
      default:
        break
    }
  }

  const setObjects = (first: LevelObject, second: LevelObject, third: LevelObject) => {
    let body = {
      ...(first?.name ? {1: first} : {}),
      ...(second?.name ? {2: second} : {}),
      ...(third?.name ? {3: third} : {}),
    }

    let totalUrlParams: any = Object.fromEntries(searchParams.entries())
    let {first: firstParams, second: secondParams, third: thirdParams, ...urlParams} = totalUrlParams

    setUrlParams(body, third?.filter_url ? urlParams : {})

    setTab((prevState: any) => ({
      ...prevState,
      ...body
    }))

    if (third?.filter_url) {
      let filterBody = {
        ...(first?.name ? {[first?.name]: first?.value} : {}),
        ...(second?.name ? {[second?.name]: second?.value} : {}),
        ...(third?.name ? {[third?.name]: third?.value} : {}),
      }

      dispatch(setFormAction({
        path: `edu/${third?.filter_url}`,
        method: 'get',
        fields: filterBody,
        action: getPlansCurrentFilterAction
      }))

      if(!_.isEmpty(urlParams)){
        handleAdminFormSubmit(body, urlParams)
      }
    } else {
      getList(first, second, third)
    }
  }

  const getList = (first: LevelObject, second: LevelObject, third: LevelObject) => {
    let body = {
      [first?.name]: first?.value,
      [second?.name]: second?.value,
      [third?.name]: third?.value,
      is_plan: 1
    }

    let url = third?.url ? `edu/${third?.url}` : 'edu/ctp'

    dispatch(getPlansCurrentCtpListAction({
      path: url,
      method: 'get',
      fields: body,
    }))
  }

  const handleClick = (item: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.PLANS_VIEW, {ctpId: item.id}),
      search: createSearchParams({
      }).toString()
    }

    navigate(path);
  }

  const TabItem = memo(({listItem}: any) => {
    return (
      <CardItem onClick={() => handleClick(listItem)}>
        <Row justify='space-between' gutter={[16, 16]} align='middle'>
          <Col span={6} style={{borderRight: '1px solid var(--c-line)', height: '100%'}}>
            <MyText size={24} color='var(--c-title-text)'>
              {listItem.group}
            </MyText>
          </Col>

          <Col span={7}>
            <Row align='middle' gutter={[16, 2]}>
              <Col span={24}>
                <MyText size={16} color='var(--c-title-text)' weight={700}>
                  {listItem.module}
                </MyText>
              </Col>

              <Col span={24}>
                <MyText size={14} color='var(--c-subtitle)'>
                  {listItem.subject}
                </MyText>
              </Col>
            </Row>
          </Col>

          <Col span={4}>
            <Row align='middle' gutter={[16, 2]} justify='center'>
              {listItem.teacher?.filter((item: any, index: any, self: any) => self.indexOf(item) === index)?.map((teacher: any) => (
                <Col span={24} key={teacher.id}>
                  <MyText size={14} color='var(--c-subtitle)'>
                    {teacher.fio}
                  </MyText>
                </Col>
              ))}
            </Row>
          </Col>
          <Col span={7}>
            <Row align='middle' gutter={[16, 2]} justify='center'>
              {
                listItem.students?.length > 3 ? (
                  <Tooltip title={(
                    <Row>
                      {
                        listItem.students?.map((child: any) => (
                          <Col span={24} key={child}>
                            <MyText color='var(--c-icon)' size={14} style={{display: 'block'}} align='right'>
                              {child}
                            </MyText>
                          </Col>
                        ))
                      }
                    </Row>
                  )}>
                    {
                      listItem.students?.slice(0, 3).map((child: any, childIndex: any) => (
                        <Col span={24} key={child}>
                          <MyText color='var(--c-icon)' size={14} style={{display: 'block'}} align='right'>
                            {child} {childIndex === 2 ? '...' : ''}
                          </MyText>
                        </Col>
                      ))
                    }
                  </Tooltip>
                ) : (
                  listItem.students?.map((child: any) => (
                    <Col span={24} key={child}>
                      <MyText color='var(--c-icon)' size={14} style={{display: 'block'}} align='right'>
                        {child}
                      </MyText>
                    </Col>
                  ))
                )
              }
            </Row>
          </Col>
        </Row>
      </CardItem>
    )
  })

  const handleAdminFormSubmit = (tabs: any, formValues: any) => {
    let currentFIlterValues = pickBy(formValues, identity)
    setUrlParams(tabs, currentFIlterValues)

    let body = {
      ...currentFIlterValues,
      [tabs[1]?.name]: tabs[1]?.value,
      [tabs[2]?.name]: tabs[2]?.value,
      [tabs[3]?.name]: tabs[3]?.value,
    }

    if(tabs[3]?.url){
      dispatch(getPlansCurrentCtpListAction({
        path: `edu/${tabs[3]?.url}`,
        method: 'get',
        fields: body,
      }))
    }
  }

  const formRender = useCallback((children: React.ReactNode) => {
    return (
      <Spin spinning={filterState.loading}>
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Form
              form={adminForm}
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
                flex: 1
              }}
              style={{padding: 12}}
              onFinish={(values: any) => handleAdminFormSubmit(tab, values)}
              onReset={() => handleAdminFormSubmit(tab, null)}
            >
              <Row gutter={8} align='bottom'>
                {
                  filterState.data?.fields?.map((field: any, fieldIndex: any) => (
                    <Col key={fieldIndex} span={24 / (filterState.data?.fields?.length + 1)} flex={1}>
                      <Form.Item label={field?.label} name={field?.name}>
                        <Select placeholder={field?.placeholder ? field?.placeholder : ''} disabled={field?.is_disabled}
                                showSearch filterOption={(input: any, option: any) => {
                          return option?.children?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
                        }}>
                          {field?.fieldValues?.map((fieldInner: any, index: any) => (
                            <Select.Option value={String(fieldInner.value)} key={"TYPE_SELECT" + index}>
                              {fieldInner.label}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  ))
                }
                <Col span={24 / (filterState.data?.fields?.length + 1)}>
                  <Row gutter={8} align='bottom'>
                    {
                      filterState.data?.fields?.length &&
                      <Col span={12}>
                        <MyButton title={t('set')} htmlType='submit' width='100%' height={40}
                                  style={{marginBottom: 12}}/>
                      </Col>
                    }

                    {
                      filterState.data?.fields?.length &&
                      <Col span={12}>
                        <MyButton title={t('reset')} htmlType='reset' width='100%' height={40}
                                  style={{marginBottom: 12}}/>
                      </Col>
                    }
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>

          <Col span={24}>
            {children}
          </Col>
        </Row>
      </Spin>
    )
  }, [filterState, tab])

  const innerTabContentItem = useMemo(() => {
    return (
      <List
        locale={{emptyText: `${t('noRecords')}`}}
        dataSource={listCurrentState.data || []}
        loading={listCurrentState.loading}
        rowKey={(record: any) => `${record.id}-listState`}
        renderItem={(listItem: any) => (
          <Row>
            <Col span={24}>
              <TabItem listItem={listItem}/>
            </Col>
          </Row>
        )}
      />
    )
  }, [listCurrentState])

  const innerTabsRenderContent = useMemo(() => {
    if (tab[3]?.filter_url) {
      return formRender(innerTabContentItem)
    } else {
      return innerTabContentItem
    }
  }, [listCurrentState, filterState, tab])


  return (
    <>
      <MyBreadcrumb title={t('lessonsPlan')}/>

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <OuterTabs items={listState?.data?.map((first: any) => {
                return {
                  key: first?.key,
                  label: first?.label,
                  children: (
                    <InnerTabs items={first.children?.map((second: any) => ({
                      key: second?.key,
                      label: second?.label,
                      children: second.children ? (
                        <InnerTabs items={second.children?.map((third: any) => ({
                          key: third?.key,
                          label: third?.label,
                          children: innerTabsRenderContent,
                        }))} onTabClick={(key: any, e: any) => handleClickTab(3, key)} activeKey={tab[3]?.key}/>
                      ) : innerTabsRenderContent,
                    }))} onTabClick={(key: any, e: any) => handleClickTab(2, key)} activeKey={tab[2]?.key}/>
                  ),
                }
              })} onTabClick={(key: any, e: any) => handleClickTab(1, key)} activeKey={tab[1]?.key}/>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
